import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { take } from 'rxjs/operators';
import { DebuggerPanelComponent } from '../public/debugger-panel/debugger-panel.component';
import { ENV_CONFIG_TOKEN } from '../shared/config';

@Injectable({
  providedIn: 'root',
})
export class LogService {
  #config = inject(ENV_CONFIG_TOKEN);
  private static baseUrl: string;
  private static errorUrl: string;
  debuggerComponent: DebuggerPanelComponent | null = null;

  constructor(private http: HttpClient) {
    LogService.baseUrl = `${this.#config.apiBaseUrl}/log`;
    LogService.errorUrl = `${LogService.baseUrl}/error`;
    window.addEventListener('error', (e) => this.handleUncaughtError(e));
    this.overrideConsole();
  }

  private handleUncaughtError(error: Error | ErrorEvent): void {
    this.error(error.message, error);
    location.reload();
  }

  public error(message: string | Error, error?: Error | ErrorEvent | HttpErrorResponse): void {
    if (error) {
      console.error(message, error);
    } else {
      console.error(message);
    }

    this.http
      .post(LogService.errorUrl, error ? error : message)
      .pipe(take(1))
      .subscribe(() => {});
  }

  public log(message: string | any): void {
    console.log(message);

    const payload = typeof message === 'string' ? message : JSON.stringify(message);

    this.http
      .post(LogService.baseUrl, payload)
      .pipe(take(1))
      .subscribe(() => {});
  }

  private overrideConsole(): void {
    // Store references to the original console methods
    const oldConsoleLog = console.log;
    const oldConsoleError = console.error;

    // Override console.log
    console.log = (message: any, ...optionalParams: any[]) => {
      this.debuggerComponent?.logMessage('log', message, ...optionalParams);
      // Call the original console.log method
      oldConsoleLog.call(console, message, ...optionalParams);
    };

    // Override console.error
    console.error = (message: any, ...optionalParams: any[]) => {
      this.debuggerComponent?.logMessage('error', message, ...optionalParams);
      // Call the original console.error method
      oldConsoleError.call(console, message, ...optionalParams);
    };
  }

  setDebuggerComponent(component: DebuggerPanelComponent): void {
    this.debuggerComponent = component;
  }
}
